import React from "react";

const getStatusModifier = (status) => {
  const s = (status || "").toLowerCase();
  if (s.includes("complete") || s === "done") return "--success";
  if (s.includes("run") || s.includes("train") || s === "in progress") return "--info";
  if (s.includes("fail") || s.includes("error")) return "--danger";
  return "--default";
};

const TrainingResultHeader = ({ model, version, modelType, onBack, onTestModel, onDownload }) => {
  const status = version?.trainingStatus || "-";
  const statusMod = getStatusModifier(status);

  return (
    <header className="training-result-header">
      <button type="button" className="training-result-header__back" onClick={onBack}>
        <i className="fa fa-arrow-left mr-1" aria-hidden /> Back to models
      </button>
      <span className="training-result-header__sep" aria-hidden="true">|</span>
      <span className="training-result-header__title">{model?.model_name || "-"}</span>
      <span className="training-result-header__badge training-result-header__badge--type">
        {(model?.model_type || model?.modelType || "-").toUpperCase()}
      </span>
      <span className="training-result-header__version">v{version?.version ?? "-"}</span>
      <span
        className={`training-result-header__badge training-result-header__badge--status training-result-header__badge${statusMod}`}
      >
        {status}
      </span>
      <div className="training-result-header__actions">
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={onTestModel}>
          <i className="fa fa-play mr-1" aria-hidden /> Test Model
        </button>
        <button type="button" className="btn btn-sm btn-primary" onClick={onDownload}>
          <i className="fa fa-download mr-1" aria-hidden /> Download
        </button>
      </div>
    </header>
  );
};

export default TrainingResultHeader;
